export default __webpack_public_path__ + "static/media/automatic-transmission1.0e6b2d1e.svg";